import { useState, useEffect } from "react";
import { Dropdown, Modal, Nav, Tab, Tabs } from "react-bootstrap";
import ComponentIcon from "../../images/code-editor-back-arrow.svg";
import DownArrowIcon from "../../images/DownArrowIcon.svg";
import UndoNewIcon from "../../images/UndoNewIcon.svg";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import LockIcon from "../../images/Lock-Icon.svg";
import CustomTooltip from "../Tooltip/Tooltip";
import SaveChangesNewIcon from "../../images/save-changes-icon.svg";
import RedoNewIcon from "../../images/RedoNewIcon.svg";
import InfoNewIcon from "../../images/InfoNewIcon.svg";
import PreviewNewIcon from "../../images/PreviewIcon.svg";
import MLRStatusGreen from "../../images/MLR StatusGreen.png";
import MLRStatusGray from "../../images/MLR StatusGray.png";
import MLRStatusRed from "../../images/MLR StatusRed.png";
import ActiveCodeEditorIcon from "../../images/code_editor_icon.svg";
import JSFolderIcon from "../../images/js-folder-icon.svg";
import ActiveJsFolderIcon from "../../images/ActiveJsFolderIcon.svg";
import InActiveCodeEditorIcon from "../../images/CodeIcon.svg";
import CloseIcon from "../../images/Close-Small.svg";
import SuccessIcon from "../../images/Success-Icon.svg";
import ErrorIcon from "../../images/Error-Icon.svg";
import LibrarySearchIcon from "../../images/library-searchIcon.svg";
import Button from "@mui/material/Button";

import "./NewCodeEditor.scss"
import "./CodeEditor.scss"

import HtmlComponent from "./HtmlComponent";
import CssComponent from "./CssComponent";
import { getDeckGlobalCss, geteDetailByID, getSlideDetailsById, getUpdatedLibrariesList, postAddCutomScripts, searchLibraries } from "../../services/apis";
import JSComponent from "./JSComponent";
import AvailableLibraries from "./AvailableLibraries";
import { useParams } from "react-router-dom";
import ImportLibraries from "./ImportLibraries";
import { showErrorToast, showSuccessToast } from "../toastComponent/ToastComponent";
import { undo, redo } from "@codemirror/commands";
import "../../css/Popup.scss";

const NewCodeEditor = ({
    editor,
    codeEditor,
    setCodeEditor,
    showAllSlides,
    showSlidesPanel,
    appData,
    currentSlideRef,
    nameDrop,
    localScripts,
    inputElement,
    setLocalScripts,
    cardInfoHandler,
    callEditor,
    setCodeEditorSave,
    setCodeEditorLoading,
}) => {
    const [codeOptions, setCodeOptions] = useState(["HTML", "CSS", "JS"]);
    const [preferredCss, setPreferedCss] = useState('Local');
    const [currentRadioValue, setCurrentRadioValue] = useState("HTML");
    const [defaultActiveTab, setDefaultActiveTab] = useState("HTML");
    const [openProceedCss, setOpenProceedCss] = useState(false);
    const [jsTab, setJsTab] = useState('edit');
    const [localLibrary, setLocalLibrary] = useState([]);
    const [sharedLibrary, setSharedLibrary] = useState([]);
    const [searchLibr, setSearchLibr] = useState("");
    const [searchedList, setSearchedList] = useState([]);
    const [showSearchResult, setShowSearchResult] = useState(false);
    const [jumpToLibraryTab, setJumpToLibraryTab] = useState(0);
    const [expandDetailDrop, setExpandDetailDrop] = useState(false);
    const [prevState, setPrevState] = useState('');
    const [closeCodeEditorModal, setCloseCodeEditorModal] = useState(false);
   
    let { pageId } = useParams();
    
    const [htmlCodeEditor, setHTMLCodeEditor] = useState("");
    const [cssCodeEditor, setCSSCodeEditor] = useState("");
    const [jsCodeEditor, setJSCodeEditor] = useState("");
    const [switchCustomJs, setSwitchCustomJs] = useState(false);
    const [checkErrors, setcheckErrors] = useState({
        html: false,
        css: false,
        js: false,
    });
    const [selectedComp, setSelectedComp]=useState("");
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [items, setItems] = useState(['Details']); // 'Export',     
    const [undoAvailable, setUndoAvailable] = useState(false);
    const [redoAvailable, setRedoAvailable] = useState(false);

    useEffect(()=>{
        setUndoAvailable(false);
        setRedoAvailable(false);
    }, [defaultActiveTab])

    useEffect(()=>{
        setTimeout(()=>setCodeEditorLoading(false), 1000);
    }, []);
    const LightTooltip = styled(({ className, ...props }) => (
        <Tooltip {...props} classes={{ popper: className }} />
      ))(({ theme }) => ({
        [`& .${tooltipClasses.arrow}`]: {
          color: theme.palette.common.white,
        },
        [`& .${tooltipClasses.tooltip}`]: {
          backgroundColor: theme.palette.common.white,
          color: "rgba(0, 0, 0, 0.87)",
          boxShadow: theme.shadows[1],
          fontSize: 11,
        },
      }));

    useEffect(() => {
        slideAssociatedLib(pageId);
        deckAssociatedLib(appData.deckId?._id);
        // setSharedLibrary(appData.deckId?._id || []);
      }, []);

    const slideAssociatedLib = (pageId) => {
        getSlideDetailsById(pageId, (res, err) => {
        if (err) {
        } else {
            setLocalLibrary(res.data.local_libraries);
        }
        });
    };

     const deckAssociatedLib = (deckId) => {
        geteDetailByID(deckId, (res, err) => {
          if (err) {
          } else {
            setSharedLibrary(res.data.shared_libraries);
          }
        });
    };

     const globalCSSGenerate =()=>{
        let JS = jsCodeEditor.current?.view.viewState.state.doc.toString();
        let CSS = cssCodeEditor.current?.view.viewState.state.doc.toString();
        const isContent = switchCustomJs ? JS.trim().length : CSS.trim().length;
        const removeUrl = isContent > 0 ? false : true;
        const globalFileObj = {"type": switchCustomJs?"js":"css",
          "content": switchCustomJs ? JS : CSS 
        }
          getDeckGlobalCss(appData.deckId._id, globalFileObj, removeUrl, (response, err, ErrorCode)=>{
            if(err){
              console.log('css err file=====================', err)
              toastError();
            }else{
              const data = response.data.response.url;
              toastSave();
            switchCustomJs? localStorage.setItem('jsglobalUrl', data) : localStorage.setItem('cssglobalUrl', data !== null ? data : '') 
            }
          }) 
    }
    
    const toastError = ()=>{
        showErrorToast('Please fix the Errors in Code');
    }

    const toastSave = () => {
        showSuccessToast('Save successful');
    }


    const handleCodeOptions = (key) => {
        const selectedOptionValue = key.toUpperCase();
        setPrevState(selectedOptionValue);
        setPreferedCss('Local');
        setSwitchCustomJs(false);
        if(selectedOptionValue !== defaultActiveTab) {
            setOpenProceedCss(true);
        }
        // editor.select();
    };

    const reDo = () => {
        if (currentRadioValue === "HTML") redo(htmlCodeEditor?.current?.view);
        else if (currentRadioValue === "CSS") redo(cssCodeEditor?.current?.view);
        else if (currentRadioValue === "JS") redo(jsCodeEditor?.current?.view);
    };
    const unDo = () => {
        if (currentRadioValue === "HTML") undo(htmlCodeEditor?.current?.view);
        else if (currentRadioValue === "CSS") undo(cssCodeEditor?.current?.view);
        else if (currentRadioValue === "JS") undo(jsCodeEditor?.current?.view);
    };

    const saveCodeEditor = () => {
        var LinkErrors = document.getElementsByClassName("cm-lint-marker-error");
        if (LinkErrors.length > 0) {
            showErrorToast('Please fix the Errors in Code');
            return;
        } else {
            if(preferredCss === 'Local' && !switchCustomJs){
                var html = htmlCodeEditor.current?.view.viewState.state.doc.toString() ||editor.getHtml();
                let cmp = editor.getSelected();
                

            
                
                var css = editor.getCss();
                
                //cssCodeEditor.current?.view.viewState.state.doc.toString() ||
                //editor?.getCss();
            
                // Regular expression to match the desired CSS block
                const regex = /#wrapper\s*{([\s\S]*?)}/;
                // Executing the regular expression on the CSS string
                const match = css.match(regex);
        
                if (match) {
                    const subString = `#wrapper {
                    position: absolute;
                    top: 0px;
                    left: 0px;
                    width: 1024px;
                    height: 768px;
                }`;
        
                    // Check if the substring is an exact match within the given string
                    const isExactMatch = css.trim() === subString.trim();
                    // console.log("Start index:", match.index);
                    // console.log("End index:", match.index + match[0].length - 1);
                    if (!isExactMatch) {
                    css = subString + css;
                    }
                } else {
                    // console.log("Match not found.");
                };
                let newCSSString= editor.getCss();

                editor.DomComponents.getWrapper().set("content", "");

                editor.setComponents(html);
               // debugger
                editor.setStyle(newCSSString);
                const wrapperDiv = editor.DomComponents.getComponents().at(0);
                if (editor.DomComponents.getComponents()?.at(0)?.ccid === "wrapper" ) {
                    wrapperDiv.set({ name: "Wrapper" });
                }
                
                let JS = jsCodeEditor.current?.view.viewState.state.doc.toString();
                validateAndAddScripts(JS);
                toastSave();
                }else{
                globalCSSGenerate()
            }    
        }
    };

    const proceedCodeEditor = () => {
        var LinkErrors = document.getElementsByClassName("cm-lint-marker-error");
         if (LinkErrors.length > 0) {
            showErrorToast('Please fix the Errors in Code');
         return;
         }
         editor.Css.addRules(cssCodeEditor.current?.view.viewState.state.doc.toString())
     }
     const proceedCodeEditorHandler = (type) => {
        if(type === 'cancel') {
            setOpenProceedCss(false);
            setCurrentRadioValue(defaultActiveTab);
        } else {
         
            editor?.select(null);
            
            setCurrentRadioValue(prevState);
            setOpenProceedCss(false);
            setDefaultActiveTab(prevState);
            if(closeCodeEditorModal) 
            {
                setCodeEditor(false);
                setCodeEditorLoading(true);
            }
            editor.refresh()
        }
     }

    const modal = () => {
        return (
            <Modal show={openProceedCss} className="unsaved-changes-modal">
                <Modal.Body>
                    <h2 className="unsaved-changes-text">Unsaved Changes</h2>
                    <h3 className="unsaved-changes-message">Changing tabs will loose all unsaved changes. <span>Are you sure?</span></h3>
                </Modal.Body>
                <div className="popupFooter">
                    <div className="popupFooterSeparator"></div>
                    <Button
                        className="btn popupFooterGrayedButton"
                        type="button"
                        onClick={() => proceedCodeEditorHandler('cancel')}
                    >
                        CANCEL
                    </Button>
                    <Button
                        className="btn popupFooterActiveButton"
                        type="button"
                        onClick={() => proceedCodeEditorHandler('proceed')}
                    >
                        PROCEED
                    </Button>
                </div>
            </Modal>
        )
    }

    const validateAndAddScripts = (jsScript) => {
        let IDRef =
          JSON.stringify(currentSlideRef?.current?.child) === "{}"
            ? currentSlideRef?.current?.master?.slideid?._id
            : currentSlideRef?.current?.child?.slideid?._id;
    
        let test = JSON.stringify({ script: jsScript });
        postAddCutomScripts(
          { script: jsScript },
          appData.deckId._id,
          IDRef,
          (res, err) => {
            if (err) {
            } else {
              setLocalScripts([...localScripts, res.data.response]);
            }
          }
        );
    };
    
    const tabSelectionHandler = (type) => {
        if(type === "edit") {
            setJsTab('edit');
        } else {
            setJsTab('js');
        }
    }

    const handleChangeSearchLibrary = (e) => {
        const val = e.target.value;
        setSearchLibr(val);
        if (val !== "") {
          searchLibraries(val, (response, err) => {
            if (err) {
            } else {
              if (response.data.success === true) {
                setSearchedList(response.data.response);
                if (response.data.response.length > 0) {
                  setShowSearchResult(true);
                } else {
                  setShowSearchResult(false);
                }
              } else {
              }
            }
          });
        }
    };

    const libraryAddedToSlides = (libName, type) => {
        updatedLibrariesList("add", libName._id, libName, type);
        setSearchLibr("");
        setShowSearchResult(false);
    };

    const updatedLibrariesList = (action, _id, libName, type) => {
        const list = type === "local" ? localLibrary : sharedLibrary;
        if (type === "local") {
          setJumpToLibraryTab(0);
        } else {
          setJumpToLibraryTab(1);
        }
        const filtered = list.filter((res) => res._id !== _id);
        const presentId = list.filter((res) => res._id === _id);
        if (action === "add" && presentId?.length > 0) {
          return;
        } else {
          list.push(libName);
        }
        const payload = { type: type, library: action === "add" ? list : filtered };
        const paramId = type === "local" ? pageId : appData?.deckId?._id;
        getUpdatedLibrariesList(paramId, payload, (res, err) => {
          if (err) {
          } else {
            const data =
              type === "local"
                ? res.data.response.local_libraries
                : res.data.response.shared_libraries;
            if (type === "local") {
              setLocalLibrary(data);
              // formatScriptTag(data);
            } else {
              setSharedLibrary(data);
            }
          }
        });
      };

      const removeLibrary = (libName, ind, type) => {
        updatedLibrariesList("remove", libName._id, libName, type);
      };

      const showResultCallBack = () => {
        setShowSearchResult(false);
        setSearchLibr("");
      };

      const expandName = () => {
        setExpandDetailDrop(!expandDetailDrop);
      };

      const toggleDropdown = (isOpen) => {
        setDropdownOpen(isOpen);
      };

      const handleButtonClick = (item) => {
        if(item === "Export") {
          editor.runCommand("export");
        } else if(item === "Details") {
          cardInfoHandler()
        }
        setDropdownOpen(false); // Close the dropdown
      };

    return (
        <div className="codeEditorPage">
            <div className="code-header-wrapper">
                <div className="d-flex align-items-center module-content-dashboard-header">
                    <div className="module-content-dashboard-image">
                        <img src={ComponentIcon} alt="" onClick={() => {setOpenProceedCss(true); setCloseCodeEditorModal(true)}}/>
                    </div>
                    <div className="module-content-dashboard-title">
                        <h4>{nameDrop.type === 1 ? "Template" : "e-Detail"} Code Editor</h4>
                        <CustomTooltip title={nameDrop?.name} classes="dashboard-title-name-tooltip">
                            <h2>{nameDrop?.name}</h2>
                        </CustomTooltip>
                    </div>
                </div>
                {/* <div className="editor-wrapper-header1">
                    <div className="dashboardIconLabel">
                        <img
                            src={ComponentIcon}
                            alt="Back Arrow"
                            onClick={() => {setOpenProceedCss(true); setCloseCodeEditorModal(true)}}
                        />

                        <span className="expandDrop">
                        <span>Code Editor / </span>{" "}
                        <span className="deckName">{nameDrop?.name}</span>
                        </span>

                        <img
                          className={`${
                            expandDetailDrop ? "collapseArrow" : "expandArrow"
                          }`}
                        src={DownArrowIcon}
                        width={15}
                        height={15}
                        alt=""
                          onClick={expandName}
                        />
                    </div>

                <div
                    className={`${expandDetailDrop ? "expandName" : "collapseName"}`}
                >
                    <div className="templateNameLabel-class">
                    <span className="presName">
                        {nameDrop?.type == 1 ? "Template" : "e-Detail"} name
                    </span>
                    {!nameDrop?.expired && (
                        <span style={{ width: "6%" }}>
                        <LightTooltip
                            className="mlrToolTip"
                            title={
                            nameDrop?.veevaMetadata?.length > 0
                                ? nameDrop?.veevaMetadata[0]?.statusMLR
                                : "Not Submitted"
                            }
                            arrow
                        >
                            <img
                            src={
                                nameDrop?.veevaMetadata[0]?.statusMLR ===
                                "Approved for Production"
                                ? MLRStatusGreen
                                : nameDrop?.veevaMetadata[0]?.statusMLR === "Rejected"
                                ? MLRStatusRed
                                : MLRStatusGray
                            }
                            alt="MLR Icon"
                            className="statusIcon"
                            />
                        </LightTooltip>
                        </span>
                    )}
                    <span>
                        {nameDrop?.locked && nameDrop?.type === 1 && (
                        <img src={LockIcon} />
                        )}
                    </span>
                    </div>
                    <div className="templateName-class">{nameDrop?.name}</div>
                </div>
                </div> */}
                <div className="d-flex main-header">
                <div style={{ flex: "0 0 1" }} className="editor-wrapper-header2">
                    {/* <div className='editor-wrapper-header-content d-flex'> */}
                    <div className="d-flex align-items-center">
                        <CustomTooltip title="Save" classes="code-save">
                            <div
                                className="editor-wrapper-header-content1 d-flex"
                                onClick={saveCodeEditor}
                            >
                                <img src={SaveChangesNewIcon} width={99} height={16} alt="" />
                            </div>
                        </CustomTooltip>
                        <div className="d-flex align-items-center code-editor-undo-redo" >
                            <div onClick={unDo} className="cursor-pointer">
                                <CustomTooltip title="Undo" classes="code-undo">
                                    <img
                                    alt="undo"
                                    src={UndoNewIcon}
                                    style={{ width: "24px", height: "18px" }}
                                    className={`codeEditorIcon${
                                        undoAvailable ? "" : " urDisabled"
                                    }`}
                                    />
                                </CustomTooltip>
                            </div>
                            <div onClick={reDo} className="cursor-pointer">
                                <CustomTooltip title="Redo" classes="code-Redo">
                                    <img
                                    alt="redo"
                                    src={RedoNewIcon}
                                    style={{ width: "24px", height: "18px" }}
                                    className={`codeEditorIcon editor-wrapper-common1${
                                        redoAvailable ? "" : " urDisabled"
                                    }`}
                                    />
                                </CustomTooltip>
                            </div>
                        </div>
                    </div>
                    
                    <div className="editor-wrapper-header-content2 d-flex">
                    <ul className="d-flex topPanelEditorIcons">
                        {/* <li 
                            // onClick={unDo}
                            >
                        <CustomTooltip title="Undo" classes="code-undo">
                            <img
                            alt="undo"
                            src={UndoNewIcon}
                            style={{ width: "24px", height: "24px" }}
                            className="codeEditorIcon"
                            />
                        </CustomTooltip>
                        </li>

                        <li
                        //   onClick={reDo}
                        // title="Redo"
                        >
                        <CustomTooltip title="Redo" classes="code-Redo">
                            <img
                            alt="redo"
                            src={RedoNewIcon}
                            style={{ width: "24px", height: "24px" }}
                            className="codeEditorIcon editor-wrapper-common1"
                            />
                        </CustomTooltip>
                        </li> */}

                        {/* <li
                        className={`flex-fill listItems 
                        `}
                        onClick={() => {
                        
                        editor.runCommand("sw-visibility");
                        }}
                    >
                        <img
                        alt="InfoIconWhite"
                        src={GridOffNewIcon}
                        style={{width: '16px', height: "16px" }}
                        className="infoIconL"
                        />
                    </li> */}
                        {/* <li className="topiconsDivider"></li> */}

                        {/* <li
                        className={`flex-fill listItems 
                        `}
                        onClick={() => {
                            cardInfoHandler();
                        }}
                        >
                        <CustomTooltip title="Info" classes="code-info">
                            <img
                            alt="InfoIconWhite"
                            src={InfoNewIcon}
                            style={{ width: "24px", height: "24px" }}
                            className="infoIconL editor-wrapper-common1"
                            />
                        </CustomTooltip>
                        </li> */}

                        <li
                        className={`flex-fill listItems 
                        `}
                        onClick={() => {
                            editor.runCommand("preview");
                        }}
                        // title="Preview"
                        >
                        <CustomTooltip title="Preview" classes="code-preview">
                            <img
                            alt="InfoIconWhite"
                            src={PreviewNewIcon}
                            style={{ width: "18px", height: "18px" }}
                            className="infoIconL"
                            />
                        </CustomTooltip>
                        </li>

                        {/* <li>
                        <button
                            className="editor-wrapper-header-publish"
                            onClick={() => {
                            editor.runCommand("export");
                            }}
                        >
                            EXPORT
                        </button>
                        </li> */}
                        <li>
                            <Dropdown
                                show={dropdownOpen}
                                onToggle={toggleDropdown}
                                className="user-action-dropdown-button"
                            >
                                <Dropdown.Toggle>
                                USER ACTION(S)
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                {items.map((item, index)=> <Dropdown.Item
                                    onClick={() => {
                                    handleButtonClick(item)}
                                    }
                                >
                                    <span>
                                    {item}
                                    </span>
                                </Dropdown.Item>)}
                                </Dropdown.Menu>
                            </Dropdown>
                        </li>
                    </ul>
                    </div>
                </div>
                </div>
            </div>
            <div className="code-editor-main-section">
                <div className="code-editor-left-section">
                    <div className="flex">
                        <Tabs
                            activeKey={defaultActiveTab.toLocaleLowerCase()}
                            transition={false}
                            id="uncontrolled-tab-example"
                            className="code-editor-tabs"
                            onSelect={handleCodeOptions}
                            // onClick={(e) => handleCodeOptions(e)}
                            >
                            <Tab id="" eventKey="html" title="HTML" className="code-editor-tabs">
                                <div className="" style={{display: 'flex'}}>
                                    <div className="code-editor-tab-content-left-section">
                                        <img src={ActiveCodeEditorIcon} alt="" />
                                    </div>
                                    <div className="code-editor-tab-content-right-section" style={{background: "#000000"}}>
                                        <div
                                            style={{
                                            display: currentRadioValue === "HTML" ? "block" : "none",
                                            }}
                                        >
                                            <HtmlComponent
                                                id="html-Code"
                                                editor={editor}
                                                setHTMLCodeEditor={setHTMLCodeEditor}
                                                checkErrors={checkErrors}
                                                setcheckErrors={setcheckErrors}
                                                defaultActiveTab={defaultActiveTab}
                                                setUndoAvailable={setUndoAvailable}
                                                setRedoAvailable={setRedoAvailable}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="css" title="CSS">
                                <div className="flex" style={{display: 'flex'}}>
                                    <div className="code-editor-tab-content-left-section">
                                        <img src={ActiveCodeEditorIcon} alt="" />
                                    </div>
                                    <div className="code-editor-tab-content-right-section">
                                        <div className="editor-CSS-Block-Content justify-content-between"
                                            style={{
                                            //   display: currentRadioValue === "CSS" && expanded.code? "flex" : "none",
                                            }}>
                                            <div>
                                                <div>
                                                    <input type="radio" id="cssLocal" checked={preferredCss==='Local'} defaultChecked value={preferredCss} name="CssFor" onClick={()=>setPreferedCss('Local')}/>
                                                    <label for="cssLocal"></label>
                                                    Local CSS
                                                </div>

                                                <div style={{marginLeft: '12px'}}>
                                                    <input type="radio" id="cssGlobal" checked={preferredCss==='Global'} value={preferredCss} name="CssFor" onClick={()=>setPreferedCss('Global')}/>
                                                    <label for="cssGlobal"></label>
                                                    Global CSS
                                                </div>
                                            </div>
                                            {/* <div>
                                                <h3 onClick={() => setOpenProceedCss(true)}>UPDATE CODE</h3>
                                            </div> */}
                                            <div>
                                                <h3 onClick={() => proceedCodeEditor(true)}>UPDATE CODE</h3>
                                            </div>
                                        </div>
                                        <div className="code-editor-text">
                                          {
                                           selectedComp?.toUpperCase()|| <p>Select a component to see its CSS</p>}  
                                        </div>
                                        <div style={{background: "#000000", width: "100%", height: "100%"}}>
                                            <div
                                                style={{
                                                display: currentRadioValue === "CSS" ? "block" : "none",
                                                }}
                                            >
                                                <CssComponent
                                                    id="css-Code"
                                                    editor={editor}
                                                    setCSSCodeEditor={setCSSCodeEditor}
                                                    checkErrors={checkErrors}
                                                    setcheckErrors={setcheckErrors}
                                                    preferredCss={preferredCss}
                                                    deckData={appData.deckId}
                                                    defaultActiveTab={defaultActiveTab}
                                                    setSelectedComp={setSelectedComp}
                                                    setUndoAvailable={setUndoAvailable}
                                                    setRedoAvailable={setRedoAvailable}
                                                    >
                                                </CssComponent>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab>
                            <Tab eventKey="js" title="JS">
                                <div className="flex" style={{display: 'flex'}}>
                                    <Tab.Container id="left-tabs-example" defaultActiveKey="edit" onSelect={tabSelectionHandler}>
                                        <div className="code-editor-tab-content-left-section">
                                            <Nav variant="pills" className="code-editor-tab-pills">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="edit">
                                                        <img src={jsTab === "edit" ? ActiveCodeEditorIcon : InActiveCodeEditorIcon} alt=""/>
                                                    </Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="js">
                                                        <img src={jsTab === "js" ? ActiveJsFolderIcon : JSFolderIcon} alt="" className="js-folder-icon"/>
                                                    </Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                        </div>
                                        <div className="code-editor-tab-content-right-section">
                                            <Tab.Content>
                                                <Tab.Pane eventKey="edit">
                                                    <div className="code-editor-custom-js-toggle d-flex align-items-center ">
                                                        <label className="toggle-label">Custom Java Scripts</label>                        
                                                            <label class="toggle-switch-btn">
                                                            <input
                                                                type="checkbox"
                                                                checked={switchCustomJs} 
                                                                name="switchToggle"
                                                                onClick={()=>setSwitchCustomJs(!switchCustomJs)}
                                                            />
                                                            <span class="toggle-switch switch-round"></span>
                                                        </label>
                                                    </div>
                                                    <div style={{background: "#000000", width: "100%", height: "100%"}}>
                                                        <div
                                                            style={{
                                                            display: currentRadioValue === "JS" ? "block" : "none",
                                                            }}
                                                        >
                                                            <JSComponent
                                                            id="JS-Code"
                                                            editor={editor}
                                                            setJSCodeEditor={setJSCodeEditor}
                                                            checkErrors={checkErrors}
                                                            setcheckErrors={setcheckErrors}
                                                            currentSlideRef={currentSlideRef}
                                                            deckData={appData.deckId}
                                                            switchCustomJs={switchCustomJs}
                                                            defaultActiveTab={defaultActiveTab}
                                                            setUndoAvailable={setUndoAvailable}
                                                            setRedoAvailable={setRedoAvailable}
                                                            ></JSComponent>
                                                        </div>
                                                    </div>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="js">
                                                    <h2 className="import-libraries-text">IMPORT LIBRARIES</h2>
                                                    <div className="d-flex template-searchRow code-editor-searchLib">
                                                        <img
                                                            alt="search"
                                                            src={LibrarySearchIcon}
                                                            className={"libsearchIcon"}
                                                        />
                                                        <input
                                                            value={searchLibr}
                                                            className="library-searchField"
                                                            style={{ fontSize: "12px" }}
                                                            type="text"
                                                            name="searchInput"
                                                            placeholder="Search by name"
                                                            onChange={(e) => handleChangeSearchLibrary(e)}
                                                            autoComplete="off"
                                                        />
                                                    </div>

                                                    {!searchLibr && (
                                                        <ImportLibraries
                                                        localLibrary={localLibrary}
                                                        sharedLibrary={sharedLibrary}
                                                        removeLibrary={removeLibrary}
                                                        jumpToLibraryTab={jumpToLibraryTab}
                                                        ></ImportLibraries>
                                                    )}
                                                    {showSearchResult && searchLibr && (
                                                        <AvailableLibraries
                                                        searchedList={searchedList}
                                                        libraryAddedToSlides={libraryAddedToSlides}
                                                        showSearchResult={showSearchResult}
                                                        setshowSearchResult={setShowSearchResult}
                                                        showResultCallBack={showResultCallBack}
                                                        localLibrary={localLibrary}
                                                        sharedLibrary={sharedLibrary}
                                                        ></AvailableLibraries>
                                                    )}
                                                </Tab.Pane>
                                            </Tab.Content>  
                                        </div>
                                    </Tab.Container>
                                </div>
                            </Tab>
                        </Tabs>
                    </div>
                </div>
                <section className="code-editor-right-section">
                    <div className="code-editor-section">
                        {
                            codeEditor && <div id="gjsEditor-o"
                                style={{width:"100%", height:"100%"}}
                                ref={inputElement}
                                className="customScrollBar"
                                >
                            <div id="gjsEditor"></div> 
                            </div>
                        }
                    </div>
                </section>
            </div>
            {modal()}
        </div>
    )
}

export default NewCodeEditor;